module.exports = __webpack_public_path__ + "img/bgcz.04a9fc4d.png";